import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { BannerInitStepDeclaration } from "./Steps/BannerInitStep";

export const bannerStartupFlow = new FlowDefinition("BannerFLow");

bannerStartupFlow.addStep(BannerInitStepDeclaration);
bannerStartupFlow.setStartStep("BannerInit_Step");

export const bannerStartupFlowDefinition = new StepDefinition({
    stepName: "BannerFLow",
    stepFlow: bannerStartupFlow,
    contextIsolation: false
})